export const setActiveTab = (activeTab) => {
    return {
        type: 'SET_ACTIVE_TAB',
        activeTab,
    };
};

export const setPartNumberQuantityList = (partNumberQuantityList) => {
    return {
        type: 'SET_PARTNUMBERQUANTITY_LIST',
        partNumberQuantityList
    };
};

export const setPartNumberQuantity = (partNumberQuantity) => {
    return {
        type: 'SET_PARTNUMBERQUANTITY',
        partNumberQuantity,
    };
};

export const get = () => {
    return {
        type: 'GET',
    };
};

export const update = (physicalConfirmation) => {
    return {
        type: 'UPDATE',
        physicalConfirmation,
    };
};

export const updateTransmissions = (transmissions) => {
    return {
        type: 'UPDATE_TRANSMISSIONS',
        transmissions,
    };
};

export const updatePhysicalConfirmationList = (physicalConfirmationList) => {
    return {
        type: 'UPDATE_LIST',
        physicalConfirmationList,
    };
};

export const updateReceipt = (receipt) => {
    return {
        type: 'UPDATE_RECEIPT',
        receipt
    };
};

export const updateReceiptStorages = (receiptStorage) => {
    return {
        type: 'UPDATE_RECEIPT_STORAGE',
        receiptStorage
    };
};

export const updateMassiveIndicator = (id, value) => {
    return {
        type: 'UPDATE_RECEIPT_MASSIVE_INDICATOR',
        id,
        value,
    };
};

export const updateVisualIndicator = (id, value) => {
    return {
        type: 'UPDATE_RECEIPT_VISUAL_INDICATOR',
        id,
        value,
    };
};

export const updateSmallPartsReceipt = (receiptId, value) => {
    return {
        type: 'UPDATE_SMALL_PARTS_CHECKED',
        receiptId,
        value
    };
};

export const addReceiptGroup = (receipt) => {
    return {
        type: 'ADD_RECEIPT_GROUP',
        receipt,
    };
};

export const removedReceiptGroup = (receipt) => {
    return {
        type: 'REMOVED_RECEIPT_GROUP',
        receipt,
    };
};

export const resetReceipsGroup = () => {
    return {
        type: 'RESET_RECEIPT_GROUP',
    };
};

export const addReceipsCimPallet = (receipt) => {
    return {
        type: 'ADD_CIMPALLET',
        receipt,
    };
};

export const removedReceipsCimPallet = (receipt) => {
    return {
        type: 'REMOVED_CIMPALLET',
        receipt,
    };
};

export const resetReceipsCimPallet = () => {
    return {
        type: 'RESET_CIMPALLET',
    };
};

export const updateLabels = (labels) => {
    return {
        type: 'UPDATE_LABELS',
        labels,
    };
};

export const updateSuppliers = (suppliers) => {
    return {
        type: 'UPDATE_SUPPLIERS',
        suppliers,
    };
};

export const setAreaConversions = (areaConversions) => {
    return {
        type: 'SET_AREA_CONVERSIONS',
        areaConversions
    };
};

export const setResourceReport = (resourceReport) => {
    return {
        type: 'SET_RESOURCE_REPORT',
        resourceReport,
    };
};

//#region  Confirmação

export const resetConfirmation = () => {
    return {
        type: 'RESET_CONFIRMATION',
    };
};

export const createConfirmation = (confirmation) => {
    return {
        type: 'CREATE_CONFIRMATION',
        confirmation,
    };
};

export const insertNewConfirmation = (confirmation) => {
    return {
        type: 'INSERT_NEW_CONFIRMATION',
        confirmation,
    };
};

export const decreaseItemBalance = (partnumberCode, value) => {
    return {
        type: 'DECREASE_RECEIPT_BALANCE',
        partnumberCode,
        value,
    };
}

export const updateDate = (partnumberCode, value, key) => {
    return {
        type: 'UPDATE_RECEIPT_DATE',
        partnumberCode,
        value,
        key
    };
};

export const clearPhysicalConfirmation = () => {
    return {
        type: 'CLEAR'
    };
};

export const setFilter = (filter) => {
    return {
        type: 'SET_FILTER',
        filter
    };
};

export const setPrintSelect = (printSelect) => {
    return {
        type: 'SET_PRINT_SELECT',
        printSelect
    };
};

export const clearPrintSelect = () => {
    return {
        type: 'CLEAR_PRINT_SELECT',
    };
};

export const setAreaConversion = (areaConversion) => {
    return {
        type: 'SET_AREA_CONVERSION',
        areaConversion
    };
};

export const setShedList = (shedList) => {
    return {
        type: 'LIST_SHEDS',
        shedList
    };
};

export const setAlternativeMdrPartnumber = (alternativeMdrPartnumber) => {
    return {
        type: 'SET_ALTERNATIVE_MDR_PARTNUMBER',
        alternativeMdrPartnumber
    };
};

export const alternativeMdrPartnumberPaged = (alternativeMdrPartnumberPaged) => {
    return {
        type: 'SET_ALTERNATIVE_MDR_PARTNUMBER_PAGED',
        alternativeMdrPartnumberPaged
    };
};

export const setQmePartNumber = (qmePartNumber) => {
    return {
        type: 'SET_QME_PARTNUMBER',
        qmePartNumber
    };
};

export const qmePartNumberPaged = (qmePartNumberPaged) => {
    return {
        type: 'SET_QME_PARTNUMBER_PAGED',
        qmePartNumberPaged
    };
};

//#endregion Confirmação
